module.exports = __webpack_public_path__ + "img/TechArmorWall3_ua.a13bc937.webp";